import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useGetMrDataQuery,
  useUpdateStatusMutation,
  useGetpobdataQuery,
  useUpdatepobstatusMutation,
} from "state/api";
import {
  Box,
  CircularProgress,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Grid,
  IconButton,
  Modal,
  ButtonGroup,
} from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import CloseIcon from "@mui/icons-material/Close";
import profileImage from "assets/MRwall.jpg";

const Sm = () => {
  const MgCd = useSelector((state) => state.global.MgCd);
  const navigate = useNavigate();
  const { data: appdata, isLoading, refetch } = useGetMrDataQuery(MgCd);
  const {
    data: pobdata,
    isLoading: pobisLoading,
    refetch: refetchPob,
  } = useGetpobdataQuery(MgCd);

  console.log("appdata", appdata);
  console.log("pobdata", pobdata);
  const [previewImage, setPreviewImage] = useState(null);
  const [updateStatus] = useUpdateStatusMutation();
  const [data, setData] = useState([]);
  const [pdata, setpdata] = useState([]);
  const [updatepobstatus] = useUpdatepobstatusMutation();
  const [approveAction, setApproveAction] = useState(null);
  const [viewMode, setViewMode] = useState("prescription");

  useEffect(() => {
    if (pobdata) setpdata(pobdata);
  }, [pobdata]);

  useEffect(() => {
    if (appdata) setData(appdata);
  }, [appdata]);

  useEffect(() => {
    if (approveAction) {
      console.log("Approval action triggered for item:", approveAction);
      setApproveAction(null);
    }
  }, [approveAction]);

  if (pobisLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const handleViewToggle = (newView) => {
    setViewMode(newView);
  };

  const handleToggleStatus = async (item, status) => {
    try {
      const payload = {
        id: item.id,
        MrMgCd: item.MrMgCd,
        MclCode: item.MclCode,
        status,
      };

      const response = await updateStatus(payload).unwrap();

      if (response.success) {
        setData((prevData) => prevData.filter((card) => card.id !== item.id));
        refetch();
        if (status === 1) {
          setApproveAction(item);
        }
      }
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const handleTogglepobstatus = async (item, status) => {
    try {
      const payload = {
        id: item.id,
        MrMgCd: item.MrMgCd,
        MclCode: item.MclCode,
        status,
      };

      const response = await updatepobstatus(payload).unwrap();

      if (response.success) {
        setpdata((prevData) => prevData.filter((card) => card.id !== item.id));
        refetchPob();
        if (status === 1) {
          setApproveAction(item);
        }
      }
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const handlePreviewImage = (pic) => setPreviewImage(pic);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      padding={3}
      sx={{
        position: "relative",
        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.2)), url(${profileImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 3,
        boxShadow: 4,
        color: "white",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h3" fontWeight="bold">
          Medical Records
        </Typography>

        {/* Added Preview Daily Data Button */}
        {/* <Button 
                    variant="contained" 
                    color="secondary"
                    onClick={() => navigate('/PreviewDailyData')}
                    sx={{ 
                        mr: 2,
                        backgroundColor: '#6a0dad',
                        '&:hover': { backgroundColor: '#5a0c9d' }
                    }}
                >
                    Preview Daily Data
                </Button> */}

        <ButtonGroup variant="contained">
          <Button
            color={viewMode === "prescription" ? "primary" : "secondary"}
            onClick={() => handleViewToggle("prescription")}
          >
            PRESCRIPTION
          </Button>
          <Button
            color={viewMode === "invoice" ? "primary" : "secondary"}
            onClick={() => handleViewToggle("invoice")}
          >
            POB
          </Button>
        </ButtonGroup>
      </Box>

      {viewMode === "prescription" ? (
        <Grid container spacing={3} justifyContent="center">
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <h4>Prescription</h4>
                <Card
                  sx={{
                    position: "relative",
                    transition: "0.3s",
                    "&:hover": { boxShadow: 8, transform: "scale(1.02)" },
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    borderRadius: 2,
                  }}
                >
                  <CardMedia
                    component="img"
                    height="160"
                    image={item.pic}
                    alt={item.DoctName}
                    onClick={() => handlePreviewImage(item.pic)}
                    sx={{ cursor: "pointer", objectFit: "cover" }}
                  />
                  <IconButton
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      backgroundColor: "rgba(0, 0, 0, 0.6)",
                      color: "white",
                      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                    }}
                    onClick={() => handlePreviewImage(item.pic)}
                  >
                    <ZoomInIcon />
                  </IconButton>
                  <CardContent sx={{ backgroundColor: "#300136" }}>
                    <Typography gutterBottom variant="h6" fontWeight="bold">
                      {item.name} ({item.HeadQrt})
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Doctor Name:</strong> {item.DoctName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Category:</strong> {item.DocCategory}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>MclCode:</strong> {item.MclCode}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Submission Date:</strong>{" "}
                      {new Date(item.SUBDATE).toLocaleDateString()}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" disabled>
                      <strong>Ignore:</strong> {item.id}
                    </Typography>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={2}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ px: 3, py: 1, borderRadius: 2 }}
                        onClick={() => handleToggleStatus(item, 1)}
                      >
                        Approve
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        sx={{ px: 3, py: 1, borderRadius: 2 }}
                        onClick={() => handleToggleStatus(item, 2)}
                      >
                        Reject
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography variant="h3" color="white">
              Great! No prescription pendings... 😎
            </Typography>
          )}
        </Grid>
      ) : (
        <Grid container spacing={3} justifyContent="center">
          {pdata && pdata.length > 0 ? (
            pdata.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <h4>Invoice</h4>
                <Card
                  sx={{
                    position: "relative",
                    transition: "0.3s",
                    "&:hover": { boxShadow: 8, transform: "scale(1.02)" },
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    borderRadius: 2,
                  }}
                >
                  <CardMedia
                    component="img"
                    height="160"
                    image={item.pic}
                    alt={item.DoctName}
                    onClick={() => handlePreviewImage(item.pic)}
                    sx={{ cursor: "pointer", objectFit: "cover" }}
                  />
                  <IconButton
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      backgroundColor: "rgba(0, 0, 0, 0.6)",
                      color: "white",
                      "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                    }}
                    onClick={() => handlePreviewImage(item.pic)}
                  >
                    <ZoomInIcon />
                  </IconButton>
                  <CardContent sx={{ backgroundColor: "#300136" }}>
                    <Typography gutterBottom variant="h6" fontWeight="bold">
                      {item.name} ({item.HeadQrt})
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Doctor Name:</strong> {item.DoctName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Category:</strong> {item.DocCategory}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>MclCode:</strong> {item.MclCode}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>No_of_strips:</strong> {item.No_of_strips}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Chemist_name:</strong> {item.Chemist_name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Chemist_address:</strong> {item.Chemist_address}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>DL_no:</strong> {item.DL_no}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>state:</strong> {item.state}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>mobile_no:</strong> {item.mobile_no}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Submission Date:</strong>{" "}
                      {new Date(item.SUBDATE).toLocaleDateString()}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" disabled>
                      <strong>Ignore:</strong> {item.id}
                    </Typography>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={2}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ px: 3, py: 1, borderRadius: 2 }}
                        onClick={() => handleTogglepobstatus(item, 1)}
                      >
                        Approve
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        sx={{ px: 3, py: 1, borderRadius: 2 }}
                        onClick={() => handleTogglepobstatus(item, 2)}
                      >
                        Reject
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography variant="h3" color="white">
              Great! No invoice pendings... 😎
            </Typography>
          )}
        </Grid>
      )}

      {/* Image Preview Modal */}
      <Modal open={!!previewImage} onClose={() => setPreviewImage(null)}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          bgcolor="rgba(0,0,0,0.8)"
          position="relative"
        >
          <IconButton
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
            }}
            onClick={() => setPreviewImage(null)}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={previewImage}
            alt="Preview"
            style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: 5 }}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default Sm;
